// Master-password screen lock for the preview/editing pages.
// NOTE: this is not real security. The password is compiled into the site's JavaScript and the API has no login of
// its own, so anyone who knows the API address can still read and change records. Replace it with a proper login
// (backed by the server) before this site is exposed to the internet.

import { cfg } from '../../runtimeConfig';

const PASSWORD = cfg('PREVIEW_PASSWORD', process.env.REACT_APP_PREVIEW_PASSWORD);
const KEY = 'cms-preview-unlocked';

// "server" = the web server (nginx basic auth) already protects /preview and the write calls, so the in-page
// password screen is skipped and no password needs to be shipped to the browser.
export const SERVER_GATE = cfg('PREVIEW_GATE', process.env.REACT_APP_PREVIEW_GATE) === 'server';

export const isConfigured = () => Boolean(PASSWORD);

export function isUnlocked() {
  try {
    return isConfigured() && sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function unlock(password) {
  if (!isConfigured() || password !== PASSWORD) return false;
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    // private mode: the screen stays unlocked until the page is reloaded
  }
  return true;
}

export function lock() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
